var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavPoi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M10.3,18.7L10.3,18.7c-4.1-0.4-7.8-2.7-9.7-6.4c-0.8-1.7-0.8-3.7,0-5.3c2.1-4.1,6.3-6.5,10.9-6.5 C16,0.4,20.2,2.9,22.3,7c0.2,0.5,0.4,0.8,0.5,1.3c0.1,0.5-0.2,0.9-0.7,1.1c-0.5,0.1-0.9-0.2-1.1-0.7c-0.1-0.4-0.2-0.6-0.4-0.9 c-1.8-3.4-5.3-5.5-9.2-5.4c-4-0.1-7.4,2-9.3,5.5c-0.6,1.2-0.6,2.5,0,3.7c1.7,3.1,4.6,5.1,8.1,5.4c0.5,0,0.8,0.5,0.8,0.9 C11.1,18.4,10.8,18.7,10.3,18.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M19.1,18.5c-0.4,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.4-0.5-0.4-0.8c0-0.4,0.1-0.6,0.4-0.8c0.2-0.2,0.5-0.4,0.8-0.4 l0,0l0,0c0.7,0,1.2,0.6,1.2,1.2S19.7,18.5,19.1,18.5L19.1,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M19.1,14c-1.8,0-3.2,1.4-3.2,3.2c0,1.2,1.1,2.7,2.9,4.4c0.1,0.1,0.4,0.1,0.5,0c1.9-1.5,2.9-3.2,2.9-4.4 C22.3,15.5,20.9,14,19.1,14 M19.1,23.4c-0.5,0-0.9-0.1-1.4-0.5c-1.7-1.4-3.7-3.5-3.7-5.7c0-2.7,2.2-5,5-5s5,2.2,5,5 c0,2.1-2,4.2-3.7,5.7C20.1,23.3,19.6,23.4,19.1,23.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M11.5,8.2c-0.8,0-1.4,0.7-1.4,1.4c0,0.8,0.7,1.4,1.4,1.4c0.8,0,1.4-0.7,1.4-1.4C12.9,8.8,12.3,8.2,11.5,8.2  M11.5,12.8c-1.8,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2S13.2,12.8,11.5,12.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPoi);
export default __webpack_public_path__ + "static/media/nav_poi.d33083173095c501ebfc12ffe5ee318f.svg";
export { ForwardRef as ReactComponent };